import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material//dialog';
import { AbstractItem, Product } from 'src/app/classes';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { DecimalPipe } from '@angular/common';
import { CurrencyPipe } from 'src/app/pipes/currency.pipe';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-item-assistent-dialog',
  templateUrl: './item-assistent-dialog.component.html',
  styleUrls: ['./item-assistent-dialog.component.css'],
  providers: [CurrencyPipe, DecimalPipe]
})
export class ItemAssistentDialogComponent implements OnDestroy, OnInit {

  formGroup: FormGroup;
  products: Product[] = [];

  get buildInDateControl(): AbstractControl {
    return this.formGroup.controls["buildInDate"];
  }
  get cancelDateControl(): AbstractControl {
    return this.formGroup.controls["cancelDate"];
  }
  get faktDateControl(): AbstractControl {
    return this.formGroup.controls["faktDate"];
  }
  get numberControl(): AbstractControl {
    return this.formGroup.controls["number"];
  }
  get productControl(): AbstractControl {
    return this.formGroup.controls["product"];
  }
  get setupPriceControl(): AbstractControl {
    return this.formGroup.controls["setupPrice"];
  }
  get rentalPriceControl(): AbstractControl {
    return this.formGroup.controls["rentalPrice"];
  }
  get purchasePriceControl(): AbstractControl {
    return this.formGroup.controls["purchasePrice"];
  }

  subscriptions: Subscription[] = [];

  constructor(
    private _dialogRef: MatDialogRef<ItemAssistentDialogComponent>,
    private _formBuilder: FormBuilder,
    private _dataService: DataService,
    private _decimalPipe: DecimalPipe,
    private _currencyPipe: CurrencyPipe
  ) {
    if (!this._dataService.allProductsLoaded && !this._dataService.allProductsLoading) {
      this.subscriptions.push(this._dataService.productsLoadedAnchor.subscribe((products: Product[]) => {
        this.products = products;
      }));
      this._dataService.loadProducts();
    } else this.products = this._dataService.products;
    this.formGroup = this._formBuilder.group({
      number: [null, Validators.required],
      product: [null],
      setupPrice: [null],
      rentalPrice: [null],
      purchasePrice: [null],
      faktDate: [null],
      cancelDate: [null],
      buildInDate: [null]
    });
    this.subscriptions.push(...[
      this.productControl.valueChanges.subscribe(() => {
        let product = this.products.find(x => x.productid === this.productControl.value);
        if (product) {
          this.setupPriceControl.setValue(this._currencyPipe.transform(product.productsetupcost));
          this.purchasePriceControl.setValue(this._currencyPipe.transform(product.productpurchasecost));
          this.rentalPriceControl.setValue(this._currencyPipe.transform(product.productrentalcost));
        } else {
          this.setupPriceControl.setValue(null);
          this.purchasePriceControl.setValue(null);
          this.rentalPriceControl.setValue(null);
        }
      })
    ]);
  }

  cancel() {
    this._dialogRef.close({
      isCanceled: true
    } as ItemAssistDialogOutput);
  }

  confirm() {
    let items: AbstractItem[] = [];
    let number = this.numberControl.value;
    let product = this.productControl.value;
    let productService: string;
    let productDesc: string;
    if (product) {
      let productObject = this._dataService.products.find(x => x.productid == product);
      if (productObject) {
        productService = productObject.productservice;
        productDesc = productObject.productdesc;
      }
    }
    let setupPrice = parseFloat((this.setupPriceControl.value as string).replace(',', '.'));
    let rentalPrice = parseFloat((this.rentalPriceControl.value as string).replace(',', '.'));
    let purchasePrice = parseFloat((this.purchasePriceControl.value as string).replace(',', '.'));
    for (var i = 0; i < number; i++) {
      items.push({
        itemcount: 1,
        itemproduct: product,
        itemservice: productService,
        itemdesc: productDesc,
        itembuildindate: this.buildInDateControl.value,
        itemfaktdate: this.faktDateControl.value,
        itemcanceldate: this.cancelDateControl.value,
        itemsetupcost: setupPrice,
        itempurchasecost: purchasePrice,
        itemrentalcost: rentalPrice
      } as AbstractItem);
    }
    this._dialogRef.close({
      isCanceled: false,
      items: items
    } as ItemAssistDialogOutput);
  }

  displayProduct(id) {
    if (!id) return "";
    let index = this.products.findIndex(x => x.productid === id);
    if (index == -1) return "";
    return this.products[index].productnumber + " " + this.products[index].productservice;
  }

  matchesProductFilter(product: Product) {
    var i;
    if (!product) return false;
    if (!this.productControl.value || this.productControl.value.length == 0) return true;
    if (product.productnumber) {
      i = product.productnumber.toLowerCase().indexOf(this.productControl.value);
      if (i > -1) return true;
    }
    if (product.productservice) {
      i = product.productservice.toLowerCase().indexOf(this.productControl.value);
      if (i > -1) return true;
    }
    return false;
  }

  ngOnDestroy(): void {
    for (let sub of this.subscriptions) sub.unsubscribe();
    this.subscriptions = [];
  }

  ngOnInit(): void {

  }

  transformAmount(element) {
    element.target.value = this._decimalPipe.transform(element.target.value, ".2-2");
  }

}

export class ItemAssistDialogOutput {
  isCanceled: boolean = false;
  items: AbstractItem[] = [];
}